export const canManageCompanyCredentials = ({ permissions = [], isAdmin = false } = {}) => {
  return isAdmin === true || permissions.includes('credential:edit') || permissions.includes('role:manage');
};
